
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/templates/Onboarding/components/preloaders';
import { SEOLandingLayoutWrapper } from '@/components/layouts/SEOLandingLayoutWrapper';
import { TranslationProvider } from '@/context/translation';
import { createLandingGetServerSideProps, type LandingPageProps, } from '@/helpers/createLandingGetServerSideProps';
import { LANDING_CONSTANTS } from '@/constants';
const MovToMp3Converter = dynamic(async () => await import('@/templates/Landing/seoLandings/mov-to-mp3-converter/MovToMp3Converter'), {
    loading: LoaderScreen,
});
const index: React.FC<LandingPageProps> = ({ locale, translations, namespace, canonicalUrl, }) => {
    return (<TranslationProvider translations={translations} locale={locale}>
			<SEOLandingLayoutWrapper namespace={namespace} serverLocale={locale} serverTranslations={translations} serverCanonical={canonicalUrl}>
				<MovToMp3Converter />
			</SEOLandingLayoutWrapper>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createLandingGetServerSideProps(LANDING_CONSTANTS.PAGE_MOV_TO_MP3_CONVERTER);

    async function __Next_Translate__getServerSideProps__1a1a20bbf41__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/mov-to-mp3-converter/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bbf41__ as getServerSideProps }
  